(function() {
  const root = document.querySelector('.qbcfg');
  if (!root) return;

  const animEls = root.querySelectorAll('.qbcfg-anim');
  if (animEls.length > 0 && typeof IntersectionObserver !== 'undefined') {
    const animIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('qbcfg-visible');
          animIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    animEls.forEach(function(el) { animIo.observe(el); });
    setTimeout(function() {
      animEls.forEach(function(el) {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('qbcfg-visible');
      });
    }, 800);
  } else {
    animEls.forEach(function(el) { el.classList.add('qbcfg-visible'); });
  }

  const state = {
    heading: 'Customise your bundle',
    tier_1_label: '1 Pack',
    tier_1_subtitle: '',
    sold_out_text: 'Sold Out',
    popular_text: 'Most Popular',
    popular_style: 'banner',
    heading_color: '#FFFFFF',
    border_color: 'rgba(255,255,255,0.1)',
    sel_border_color: '#F35D9C',
    pop_border_color: '#F35D9C',
    pop_banner_bg: '#F35D9C',
    pop_banner_text: '#FFFFFF',
    disc_bg: '#16A34A',
    disc_text: '#FFFFFF',
    opt_bg: 'rgba(255,255,255,0.02)',
    sel_opt_bg: '#2A1A24',
    sub_price_color: 'rgba(255,255,255,0.5)',
    price_color: '#FFFFFF',
    border_radius: 8
  };

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return root.querySelectorAll(sel); }

  const qbWrap = root.querySelector('.qbcfg__qb');
  const hint = root.querySelector('[data-qbcfg-hint]');
  const optionsWrap = root.querySelector('[data-qbcfg-options]');
  const expanded = root.querySelector('[data-qbcfg-expanded]');
  const expImg = root.querySelector('[data-qbcfg-exp-img]');
  const expName = root.querySelector('[data-qbcfg-exp-name]');
  const expPrice = root.querySelector('[data-qbcfg-exp-price]');
  const expPriceOrig = root.querySelector('[data-qbcfg-exp-price-orig]');
  const varsList = root.querySelector('[data-qbcfg-vars-list]');
  const closeBtn = root.querySelector('[data-qbcfg-close]');

  function buildVarsRows(qty) {
    if (!varsList) return;
    let html = '';
    for (let i = 1; i <= qty; i++) {
      html += '<div class="qbcfg__qb-vars-row">' +
        '<span class="qbcfg__qb-vars-num">#' + i + '</span>' +
        '<div class="qbcfg__qb-vars-sel"><span>Vanilla</span><span>▾</span></div>' +
        '<div class="qbcfg__qb-vars-sel"><span>Whole Bean</span><span>▾</span></div>' +
        '</div>';
    }
    varsList.innerHTML = html;
  }

  function buildExpImage(stack) {
    if (!expImg) return '';
    if (stack === '1') {
      return '<div class="qbcfg__qb-bag qbcfg__qb-bag--brown"></div>';
    } else if (stack === '2') {
      return '<div class="qbcfg__qb-stack-2"><div class="qbcfg__qb-bag qbcfg__qb-bag--brown"></div><div class="qbcfg__qb-bag qbcfg__qb-bag--tan"></div></div>';
    } else if (stack === '4') {
      return '<div class="qbcfg__qb-stack-4"><div class="qbcfg__qb-bag qbcfg__qb-bag--brown"></div><div class="qbcfg__qb-bag qbcfg__qb-bag--tan"></div><div class="qbcfg__qb-bag qbcfg__qb-bag--cream"></div><div class="qbcfg__qb-bag qbcfg__qb-bag--brown"></div></div>';
    }
    return '';
  }

  function expandTier(o) {
    const qty = parseInt(o.dataset.qbcfgQty) || 1;
    const stack = o.dataset.qbcfgStack;
    const name = o.dataset.qbcfgName;
    const price = o.dataset.qbcfgPrice;
    const priceOrig = o.dataset.qbcfgPriceOrig;

    if (expImg) expImg.innerHTML = buildExpImage(stack);
    if (expName) expName.textContent = name;
    if (expPrice) expPrice.textContent = price;
    if (expPriceOrig) expPriceOrig.textContent = priceOrig || '';

    buildVarsRows(qty);

    if (optionsWrap) optionsWrap.classList.add('is-hidden');
    if (expanded) expanded.classList.add('is-open');
    if (hint) hint.classList.add('is-hidden');
  }

  function collapseTier() {
    if (optionsWrap) optionsWrap.classList.remove('is-hidden');
    if (expanded) expanded.classList.remove('is-open');
    if (hint) hint.classList.remove('is-hidden');
    $$('.qbcfg__qb-option').forEach(function(x) { x.classList.remove('is-on'); });
    render();
  }

  function render() {
    const headingEl = $('#qbcfgQbHeading');
    if (headingEl) {
      headingEl.textContent = state.heading;
      headingEl.style.color = state.heading_color;
    }

    const tier1Label = $('#qbcfgTier1Label');
    if (tier1Label) tier1Label.textContent = state.tier_1_label;

    const tier1Sub = $('#qbcfgTier1Sub');
    if (tier1Sub) {
      tier1Sub.textContent = state.tier_1_subtitle;
      tier1Sub.style.color = state.sub_price_color;
    }

    const popText = $('#qbcfgPopText');
    if (popText) popText.textContent = state.popular_text;

    const popBanner = $('#qbcfgPopBanner');
    if (popBanner) {
      popBanner.style.background = state.pop_banner_bg;
      popBanner.style.color = state.pop_banner_text;
    }

    if (qbWrap) qbWrap.dataset.style = state.popular_style;

    $$('.qbcfg__qb-option').forEach(function(o) {
      o.style.borderRadius = state.border_radius + 'px';
      const isPopular = o.hasAttribute('data-qbcfg-popular');
      if (o.classList.contains('is-on')) {
        o.style.borderColor = state.sel_border_color;
        o.style.background = state.sel_opt_bg;
      } else if (isPopular) {
        o.style.borderColor = state.pop_border_color;
        o.style.background = state.opt_bg;
      } else {
        o.style.borderColor = state.border_color;
        o.style.background = state.opt_bg;
      }
    });

    $$('[data-qbcfg-price-of]').forEach(function(p) { p.style.color = state.price_color; });
    $$('[data-qbcfg-price-orig]').forEach(function(p) { p.style.color = state.sub_price_color; });

    $$('.qbcfg__qb-disc').forEach(function(d) {
      d.style.background = state.disc_bg;
      d.style.color = state.disc_text;
    });

    $$('[data-qbcfg-sub] .qbcfg__sub-option').forEach(function(o) {
      o.style.borderRadius = state.border_radius + 'px';
      const radio = o.querySelector('.qbcfg__sub-radio');
      if (o.classList.contains('is-on')) {
        o.style.borderColor = state.sel_border_color;
        o.style.background = state.sel_opt_bg;
        if (radio) {
          radio.style.borderColor = state.sel_border_color;
          radio.style.setProperty('--qbcfg-radio-dot', state.sel_border_color);
        }
      } else {
        o.style.borderColor = state.border_color;
        o.style.background = state.opt_bg;
        if (radio) {
          radio.style.borderColor = '';
          radio.style.removeProperty('--qbcfg-radio-dot');
        }
      }
    });

    const subBadge = root.querySelector('[data-qbcfg-sub] .qbcfg__sub-badge');
    if (subBadge) {
      subBadge.style.background = state.disc_bg;
      subBadge.style.color = state.disc_text;
    }

    $$('[data-swatches]').forEach(function(group) {
      const key = group.dataset.swatches;
      const val = state[key];
      group.querySelectorAll('.qbcfg__sw').forEach(function(sw) {
        sw.classList.toggle('is-on', sw.dataset.color && sw.dataset.color.toLowerCase() === (val || '').toLowerCase());
      });
    });

    $$('[data-color-pip]').forEach(function(pip) {
      const key = pip.dataset.colorPip;
      const val = state[key] || '';
      pip.style.background = val;
    });

    $$('[data-color-input]').forEach(function(input) {
      const key = input.dataset.colorInput;
      if (document.activeElement !== input) {
        const val = state[key] || '';
        input.value = val.startsWith('#') ? val.toUpperCase() : val;
      }
    });

    $$('[data-qbcfg-seg]').forEach(function(group) {
      const key = group.dataset.qbcfgSeg;
      const val = state[key];
      group.querySelectorAll('.qbcfg__seg-btn').forEach(function(btn) {
        btn.classList.toggle('is-on', btn.dataset.val === val);
      });
    });

    $$('[data-qbcfg-show-when]').forEach(function(el) {
      const cond = el.dataset.qbcfgShowWhen;
      const parts = cond.split(':');
      const key = parts[0];
      const expected = parts[1];
      el.style.display = state[key] === expected ? '' : 'none';
    });
  }

  $$('[data-qbcfg-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      state[input.dataset.qbcfgInput] = input.value;
      render();
    });
  });

  $$('[data-qbcfg-seg] .qbcfg__seg-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const group = btn.closest('[data-qbcfg-seg]');
      state[group.dataset.qbcfgSeg] = btn.dataset.val;
      render();
    });
  });

  $$('.qbcfg__sw[data-color]').forEach(function(sw) {
    sw.addEventListener('click', function() {
      const group = sw.closest('[data-swatches]');
      state[group.dataset.swatches] = sw.dataset.color;
      render();
    });
  });

  $$('[data-color-input]').forEach(function(input) {
    input.addEventListener('input', function() {
      const key = input.dataset.colorInput;
      let val = input.value.trim();
      if (val.startsWith('rgba') || val.startsWith('rgb')) {
        state[key] = val;
        render();
        return;
      }
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val) || /^#[0-9A-Fa-f]{3}$/.test(val)) {
        state[key] = val;
        render();
      }
    });
  });

  $$('[data-slider]').forEach(function(slider) {
    const key = slider.dataset.slider;
    const min = parseInt(slider.dataset.min);
    const max = parseInt(slider.dataset.max);
    const fill = slider.querySelector('.qbcfg__slider-fill');
    const knob = slider.querySelector('.qbcfg__slider-knob');
    const valEl = root.querySelector('[data-slider-val="' + key + '"]');

    function setFromValue(val) {
      val = Math.max(min, Math.min(max, val));
      val = Math.round(val);
      state[key] = val;
      const pct = ((val - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      knob.style.left = pct + '%';
      if (valEl) valEl.value = val;
      render();
    }

    function setFromX(clientX) {
      const rect = slider.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      setFromValue(min + pct * (max - min));
    }

    let dragging = false;
    slider.addEventListener('mousedown', function(e) {
      dragging = true;
      setFromX(e.clientX);
      e.preventDefault();
    });
    document.addEventListener('mousemove', function(e) { if (dragging) setFromX(e.clientX); });
    document.addEventListener('mouseup', function() { dragging = false; });
    slider.addEventListener('touchstart', function(e) { dragging = true; setFromX(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchmove', function(e) { if (dragging) setFromX(e.touches[0].clientX); }, { passive: true });
    document.addEventListener('touchend', function() { dragging = false; });
  });

  $$('[data-qbcfg-sub] .qbcfg__sub-option').forEach(function(o) {
    o.addEventListener('click', function() {
      $$('[data-qbcfg-sub] .qbcfg__sub-option').forEach(function(x) { x.classList.remove('is-on'); });
      o.classList.add('is-on');
      render();
    });
  });

  $$('.qbcfg__qb-option').forEach(function(o) {
    o.addEventListener('click', function() {
      $$('.qbcfg__qb-option').forEach(function(x) { x.classList.remove('is-on'); });
      o.classList.add('is-on');
      expandTier(o);
      render();
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      collapseTier();
    });
  }

  const grid = $('#qbcfgGrid');
  const seeLiveBtn = $('#qbcfgSeeLive');
  if (seeLiveBtn && grid) {
    seeLiveBtn.addEventListener('click', function() {
      const isPreview = grid.classList.toggle('is-preview');
      seeLiveBtn.classList.toggle('is-back', isPreview);
      if (isPreview) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  render();
})();

(function() {
  var sections = document.querySelectorAll('.qbcfg');
  if (!sections.length) return;
  var headerHideObserver = new IntersectionObserver(function(entries) {
    var anyVisible = entries.some(function(e) { return e.isIntersecting; });
    if (anyVisible) {
      document.body.classList.add('qbcfg-section-active');
    } else {
      var stillVisible = false;
      sections.forEach(function(el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.5 && r.bottom > 80) stillVisible = true;
      });
      if (!stillVisible) document.body.classList.remove('qbcfg-section-active');
    }
  }, { threshold: 0, rootMargin: '-80px 0px -50% 0px' });
  sections.forEach(function(sec) { headerHideObserver.observe(sec); });
})();